import { QuestionCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Popover,
  Radio,
  Row,
  message,
} from "antd";
import { useEffect, useState } from "react";
import TermsOfService from "components/form/commons/TermsOfService";
import {
  Title,
  SubText,
  ContentContainer,
  MyCaseSection,
  Container,
  CaseDetailWrapper2,
} from "../../../Form.style";

const { TextArea } = Input;

const Step4 = ({ data, setData, onPrev, onNext, itemLayout }) => {
  const [submitting, setSubmitting] = useState(false);
  const key = "updatable";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (submitting) {
      message.success({
        content: "제출 완료!",
        key,
        duration: 2,
      });
      onNext();
    }
  }, [submitting]);

  const onFinish = async (values) => {
    await setData(values);
    setSubmitting(true);
  };

  return (
    <Container style={{ textAlign: "left" }}>
      <MyCaseSection>
        <ContentContainer>
          <Title>추가 정보 및 제출</Title>
          <div style={{ marginTop: 10 }}>
            <SubText type="secondary">
              기타 사항 및 변호사 검토 시 <br />
              참고해야 할 내용이 있다면 아래에 작성하세요.
            </SubText>
          </div>
          <Divider style={{ marginTop: 10 }} />
          <CaseDetailWrapper2>
            <Form
              {...itemLayout.form}
              layout="horizontal"
              onFinish={onFinish}
              initialValues={data}
              style={{
                marginTop: 10,
                marginBottom: 20,
                width: "100%",
                textAlign: "left",
              }}
              requiredMark={false}
            >
              <Form.Item
                label="보유 서류"
                name={["documents"]}
              >
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    <Col span={12}>
                      <Checkbox value="contract">임대차계약서</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="certification">내용증명 사본</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="registry">등기부등본</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="overdue_proof">차임 연체 증빙</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                label={
                  <>
                    가처분 신청 희망
                    <Popover
                      content={
                        <div>
                          점유이전금지 가처분을 함께 신청하면
                          <br />
                          임차인이 제3자에게 점유를 이전하는 것을
                          <br />
                          방지할 수 있습니다.
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["injunctionRequest"]}
                rules={[
                  {
                    required: true,
                    message: "가처분 신청 희망 여부를 선택해주세요",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio.Button value="y">예</Radio.Button>
                  <Radio.Button value="n">아니오</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label={
                  <>
                    밀린 차임 청구 희망
                    <Popover
                      content={
                        <div>
                          명도소송과 함께 밀린 차임(월세)이나
                          <br />
                          관리비를 청구할 수 있습니다.
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["overdueClaimRequest"]}
                rules={[
                  {
                    required: true,
                    message: "밀린 차임 청구 희망 여부를 선택해주세요",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio.Button value="y">예</Radio.Button>
                  <Radio.Button value="n">아니오</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label={
                  <>
                    기타내용
                    <Popover
                      content={
                        <div>
                          검토 시 필요한 기타 사항을 500자 내로 작성해주세요
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["description"]}
              >
                <TextArea rows={10} maxLength={500} />
              </Form.Item>

              <Form.Item
                label="연락처"
                name={["contact"]}
                rules={[
                  {
                    required: true,
                    message: "연락처를 입력해주세요",
                  },
                ]}
              >
                <Input placeholder="검토 결과 알림을 받으실 연락처를 입력해주세요" />
              </Form.Item>

              <Form.Item label="프로모션 코드" name={["promotionCode"]}>
                <Input />
              </Form.Item>
              <TermsOfService />

              <Row justify="space-between" style={{ marginTop: 20 }}>
                <Col span={6}>
                  <Button
                    type="primary"
                    onClick={onPrev}
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    이전
                  </Button>
                </Col>
                <Col span={6} offset={10} style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    {submitting ? "제출 중" : "제출"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </CaseDetailWrapper2>
        </ContentContainer>
      </MyCaseSection>
    </Container>
  );
};

export default Step4;
